import * as React from "react";
import { Text, ActionIcon, Grid } from "@mantine/core";
import { Control, useFieldArray } from "react-hook-form";
import { IconPlus, IconTrash } from "@tabler/icons-react";

import { ReconsetCVMContext } from "../../ReconsetCVM";
import {
  CTextInput,
  CSelect,
} from "@supportinitiative/react-hook-form-mantine";

const orderOperators = [
  {
    value: "ASC",
    label: "Ascending",
  },
  {
    value: "DESC",
    label: "Descending",
  },
];

function Statements({
  name,
  index,
  statementsArray,
  control,
}: {
  name:
    | `definition.recons.${number}.definition.actions.${number}.definition.left.order.statements.${number}`
    | `definition.recons.${number}.definition.actions.${number}.definition.right.order.statements.${number}`
    | `definition.recons.${number}.definition.actions.${number}.definition.searchFor.left.order.statements.${number}`
    | `definition.recons.${number}.definition.actions.${number}.definition.searchIn.left.order.statements.${number}`
    | `left.order.statements.${number}`
    | `right.order.statements.${number}`;
  index: number;
  statementsArray: any;
  control: Control<any>;
}) {
  const { state: reconsetCVMState } = React.useContext(ReconsetCVMContext);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginLeft: "40px",
      }}
    >
      <Grid align="stretch" gutter={"xs"} style={{ marginBottom: "5px" }}>
        <Grid.Col span={4}>
          <CTextInput
            name={`${name}.left`}
            control={control}
            label={index === 0 ? "Left" : ""}
            disabled={reconsetCVMState.actionOptions.disableAll}
          />
        </Grid.Col>
        <Grid.Col span={4}>
          <CSelect
            name={`${name}.operator`}
            control={control}
            searchable
            data={orderOperators}
            label={index === 0 ? "Operator" : ""}
            disabled={reconsetCVMState.actionOptions.disableAll}
          />
        </Grid.Col>

        <Grid.Col
          span={1}
          style={{
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              statementsArray.remove(index);
            }}
            disabled={reconsetCVMState.actionOptions.disableAll}
            style={{
              display: reconsetCVMState.actionOptions.disableAll ? "none" : "",
            }}
          >
            <IconTrash />
          </ActionIcon>
        </Grid.Col>
      </Grid>
    </div>
  );
}

function Order({
  name,
  control,
}: {
  name:
    | `definition.recons.${number}.definition.actions.${number}.definition.left.order`
    | `definition.recons.${number}.definition.actions.${number}.definition.right.order`
    | `definition.recons.${number}.definition.actions.${number}.definition.searchFor.left.order`
    | `definition.recons.${number}.definition.actions.${number}.definition.searchIn.left.order`
    | `left.order`
    | `right.order`;
  control: Control<any>;
}) {
  const statementsArray = useFieldArray({
    control,
    name: `${name}.statements`,
  });

  const { state: reconsetCVMState } = React.useContext(ReconsetCVMContext);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        marginBottom: "20px",
        width: "90%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Text fw={500} style={{ fontSize: "14px" }}>
          Order
        </Text>
        <ActionIcon
          size="sm"
          variant="white"
          color="gray"
          onClick={() => {
            statementsArray.append({ operator: "ASC" });
          }}
          disabled={reconsetCVMState.actionOptions.disableAll}
        >
          <IconPlus />
        </ActionIcon>
      </div>

      {statementsArray.fields.map((field, index) => {
        return (
          <Statements
            name={`${name}.statements.${index}`}
            control={control}
            key={field.id}
            index={index}
            statementsArray={statementsArray}
          />
        );
      })}
    </div>
  );
}

export default Order;
